import type { DailySalesReport } from '../../../../api/daily-sales';
import { BucketError } from '../../regional/BucketStates';
import { includesAny, RETAIL_SOURCES } from '../daily-sales-filters';
import { longDate, type SourceKey } from '../daily-sales-format';
import { retailStopsAt } from '../daily-sales-range';

const FAREHARBOR_DOWN = new Error(
  'FareHarbor numbers are unavailable right now because the data warehouse could not be read. Nebari numbers are current.',
);

const RETAIL_DOWN = new Error(
  'Retail numbers are unavailable right now because the data warehouse could not be read.',
);

interface DailySalesNoticesProps {
  report: DailySalesReport;
  sources: SourceKey[];
}

/** Warnings about sources the report could not read, or read stale. */
export function DailySalesNotices({ report, sources }: DailySalesNoticesProps) {
  const fareharborDown =
    includesAny(sources, ['fareharbor', 'giftCards']) &&
    report.days.some((d) => d.fareharbor === null);
  const showsRetail = includesAny(sources, RETAIL_SOURCES);
  const retailDown = showsRetail && report.days.some((d) => d.retailInStore === null);
  const stopsAt = showsRetail && !retailDown ? retailStopsAt(report) : null;

  return (
    <>
      {fareharborDown && <BucketError error={FAREHARBOR_DOWN} />}
      {retailDown && <BucketError error={RETAIL_DOWN} />}
      {stopsAt && (
        <BucketError
          error={
            new Error(
              `Retail numbers stop at ${longDate(stopsAt)}: Shopify sales since then haven't reached the data warehouse yet.`,
            )
          }
        />
      )}
    </>
  );
}
